import React from 'react'
import { ReadOnlyContext } from 'utils/lifecycle'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useBusinessUser } from 'utils/roles'
import { SUPPORT_EMAILS, mailto } from 'utils/supportEmails'
import { Alert, Link } from '@mui/material'
import { useAdminData } from './shared'
export const ReadOnlyProvider = ({ children }) => {
  const location = useLocation()
  const restricted = useSelector(state => state.user.details?.lifecycleStatus === 'SUSPENDED' || (location.pathname.startsWith('/business') && ['SUSPENDED', 'ARCHIVED'].includes(state.business?.lifecycleStatus)))
  return <ReadOnlyContext.Provider value={restricted}>{children}</ReadOnlyContext.Provider>
}
export default function ReadOnlyNotice({ business = false }) {
  const businessUser = useBusinessUser()
  const userState = useSelector(state => state.user.details?.lifecycleStatus)
  const businessState = useSelector(state => state.business?.lifecycleStatus)
  const userSuspended = userState === 'SUSPENDED'
  const businessRestricted = business && ['SUSPENDED', 'ARCHIVED'].includes(businessState)
  const businessId = useSelector(state => state.business?.businessId)
  const { data: userLifecycle } = useAdminData(userSuspended ? '/user/me/lifecycle' : null)
  const { data: businessLifecycle } = useAdminData(businessRestricted && businessId ? `/business/${businessId}/lifecycle` : null)
  const reason = data => data?.latestChange?.reasonCode ? <div>Reason: {data.latestChange.reasonCode.replaceAll('_', ' ').toLowerCase()}.</div> : null
  if (!userSuspended && !businessRestricted) return null
  return <Alert severity="warning" sx={{ my: 2 }}>
    {userSuspended && <div>Your account is suspended. You can sign in and view retained data, but changes are restricted. {businessUser && 'This does not change the status of your businesses.'}{reason(userLifecycle)}</div>}
    {businessRestricted && <div>{businessState === 'ARCHIVED'
      ? 'This business is archived (closed). You can still view its retained data, but business changes, public offer exposure, new claims and billing are stopped. Archiving this business does not close your login account or other businesses.'
      : 'This business is suspended. You can still view its retained data, but business changes, public offer exposure, new claims and billing are paused. Suspending this business does not suspend your login account or other businesses.'}{reason(businessLifecycle)}</div>}
    <div>Contact <Link href={mailto(SUPPORT_EMAILS.help)}>{SUPPORT_EMAILS.help}</Link> for administrator review.</div>
  </Alert>
}
